var _path, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFilterUseSvg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 21.5H10.5C10.1022 21.5 9.72064 21.342 9.43934 21.0607C9.15804 20.7794 9 20.3978 9 20V14.3075L3.4425 8.75C3.16081 8.46999 3.00167 8.08968 3 7.6925V5C3 4.60218 3.15804 4.22064 3.43934 3.93934C3.72064 3.65804 4.10218 3.5 4.5 3.5H19.5C19.8978 3.5 20.2794 3.65804 20.5607 3.93934C20.842 4.22064 21 4.60218 21 5V7.6925C20.9983 8.08968 20.8392 8.46999 20.5575 8.75L15 14.3075V20C15 20.3978 14.842 20.7794 14.5607 21.0607C14.2794 21.342 13.8978 21.5 13.5 21.5ZM4.5 5V7.6925L10.5 13.6925V20H13.5V13.6925L19.5 7.6925V5H4.5Z",
    fill: "#06813E"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 4,
    r: 3,
    fill: "#D5393C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterUseSvg);
export default __webpack_public_path__ + "static/media/filter-use-svg.5263d534f8bc106fbee8115bd3024d90.svg";
export { ForwardRef as ReactComponent };